"use client";

import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import Button from "../ui/Button";
import FadeIn from "../ui/FadeIn";

export default function HowToUse({
  showTitle = true,
  imageSrc = "/images/assets/howToUseNew.png",
}: {
  showTitle?: boolean;
  imageSrc?: string;
}) {
  return (
    <section className="bg-white px-4 py-10 text-center md:py-16">
      {showTitle && (
        <FadeIn delay={0.1} direction="up">
          <h2 className="text-3xl sm:text-4xl font-medium leading-tight md:text-6xl text-primary-dark">
            Travel smarter
            <br />
            Explore deeper
            <br />
            Connect with locals.
          </h2>
        </FadeIn>
      )}

      <div className="mx-auto mt-10 max-w-5xl">
        <FadeIn delay={0.2} direction="up">
          <h3 className="text-2xl sm:text-3xl font-medium text-zinc-900">
            How to use AdviSify
          </h3>
          <p className="mx-auto mt-3 text-sm sm:text-base max-w-lg text-zinc-600">
            Getting started with AdviSify is simple. Follow these steps to
            connect with local advisors and enhance your travel experience.
          </p>
        </FadeIn>
        <FadeIn delay={0.3} direction="up" fullWidth>
          <motion.div
            whileHover={{
              y: [-5, -12, -5],
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            }}
            transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
            className="relative mt-10 w-full overflow-hidden rounded-4xl shadow-xl ring-1 ring-black/5 group bg-white"
          >
            {/* Subtle overlay glare effect on hover for a premium feel */}
            <div className="absolute inset-0 bg-linear-to-tr cursor-pointer from-white/0 via-white/15 to-white/0 opacity-0 group-hover:opacity-100 group-hover:animate-[pulse_1s_ease-in-out_infinite] z-10" />
            <motion.div
              whileHover={{ scale: [1.02, 1.05, 1.02] }}
              transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
              className="w-full h-full"
            >
              <Image
                src={imageSrc}
                alt="How it works"
                width={1200}
                height={600}
                className="w-full object-contain"
              />
            </motion.div>
          </motion.div>
        </FadeIn>
        <FadeIn delay={0.4} direction="up">
          <p className="mx-auto mt-8 text-lg font-semibold max-w-3xl text-zinc-700">
            With AdviSify, you get real-time, authentic advice from locals who
            are passionate about sharing their city with you.
          </p>
          <Button
            variant="secondary"
            shape="rounded"
            size="sm"
            className="mt-6 text-[15px] font-semibold text-[#0A2B1C] hover:bg-[#bef264]"
          >
            Get Started for Free
          </Button>
        </FadeIn>
      </div>
    </section>
  );
}
